import React from "react";

const holder = {
  closeFilterDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ selectedOptionIds: holder.selectedOptionIds });

      holder.internalStateSetter({ isOpen: false, pageNumber: 1 });
      document.removeEventListener("mousedown", holder.closeFilterDropdownSelector)
    }
  }
};

export default {
  'SubscriptionHeaderFilter.Wrapper.Header': async ({ isOpen, containerRef, isReadonly, inputRef, selectedOptionIds }, outlet, internalStateSetter) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }


    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.outlet = outlet;
    holder.selectedOptionIds = selectedOptionIds;

    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()

    document.addEventListener("mousedown", holder.closeFilterDropdownSelector);
  },
  'SubscriptionHeaderFilter.Wrapper.Header.SearchWrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchTerm: value, pageNumber: 1 })
  },
  'SubscriptionHeaderFilter.Wrapper.Header.Button': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedOptionIds: [] });
    internalStateSetter({ isOpen: false });
    document.removeEventListener("mousedown", holder.closeFilterDropdownSelector)
  },
  'SubscriptionHeaderFilter.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Option': ({ id, selectedOptionIds, singleSelect }, outlet, internalStateSetter) => {
    if (singleSelect || id === 'NO_TAG') {
      outlet({ selectedOptionIds: [id] });
      internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeFilterDropdownSelector);
      return;
    }

    const newSelectedOptionIds = [...selectedOptionIds.filter(id => id !== 'NO_TAG')];
    if (newSelectedOptionIds.includes(id)) {
      const index = newSelectedOptionIds.indexOf(id);
      newSelectedOptionIds.splice(index, 1)
    } else {
      newSelectedOptionIds.push(id);
    }

    internalStateSetter({ selectedOptionIds: newSelectedOptionIds });
    holder.selectedOptionIds = newSelectedOptionIds;
  },
  'SubscriptionHeaderFilter.Wrapper.DropdownWrapper.BorderWrapper.ClearAllHeader.ClearAll': ({ selectedOptionIds, options, searchTerm }, _, internalStateSetter) => {
    if (selectedOptionIds.length > 0) {
      internalStateSetter({ selectedOptionIds: [] });
      holder.selectedOptionIds = [];
    } else {
      let selected = options.filter(option => new RegExp(searchTerm, 'i').test(option.displayName))
      selected = selected.map(o => o.id)
      internalStateSetter({ selectedOptionIds: selected });
      holder.selectedOptionIds = selected;
    }
  },
  'SubscriptionHeaderFilter.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
}